import React from 'react'
import classNames from 'classnames'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Tooltip from '@mui/material/Tooltip'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import './underlineNavigationTabs.scss'

export interface UnderlineNavigationTab {
    name: string
    onClick: () => void
    current: boolean
    href?: string
    disabled?: boolean
    disabledReason?: string
    icon?: LucideIconName
}

export function UnderlineNavigationTabs({ tabs, className }: { tabs: UnderlineNavigationTab[]; className?: string }) {
    const currentIndex = tabs.findIndex((tab) => tab.current)

    return (
        <Tabs
            value={currentIndex === -1 ? false : currentIndex}
            onChange={(event, index: number) => {
                const tab = tabs[index]

                if (!tab || tab.disabled || tab.current) {
                    return
                }

                const mouseEvent = event as React.MouseEvent

                if (tab.href && (mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey)) {
                    return
                }

                if (tab.href) {
                    mouseEvent.preventDefault()
                }

                tab.onClick()
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            className={classNames('underline-navigation-tabs', className)}
        >
            {tabs.map((tab) => {
                const disabled = !!tab.disabled && !tab.current

                const linkProps = tab.href && !disabled ? { component: 'a', href: tab.href } : {}

                const tabElement = (
                    <Tab
                        key={tab.name}
                        {...linkProps}
                        aria-disabled={disabled || undefined}
                        className={classNames('underline-navigation-tab', { disabled })}
                        label={
                            tab.icon ? (
                                <span className="underline-navigation-tab-label">
                                    {tab.name}
                                    <LucideIcon iconName={tab.icon} size={14} />
                                </span>
                            ) : (
                                tab.name
                            )
                        }
                    />
                )

                if (disabled && tab.disabledReason) {
                    return (
                        <Tooltip key={tab.name} title={tab.disabledReason} describeChild>
                            {tabElement}
                        </Tooltip>
                    )
                }

                return tabElement
            })}
        </Tabs>
    )
}
